<template>
    <div class="brand-container noPrint">
        <div class="container">
            <div class="row">
                <div class="col-md-12">

                    <div class="coat-of-arms">
                        <img src="@/assets/images/bgnd-coat-of-arms-mini.gif" alt="Sodstvo Republike Slovenije"/>
                        Sodstvo Republike
                        Slovenije
                    </div>

                    <div class="row appTitle">
                        <div class="col-md-3">
                                <img src="@/assets/images/vsrs.png" alt={logo} class="brand"/>
                        </div>

                        <div class="col-md-9">
                            <div class="info-board info-board-gray">
                                <div class="first-line">
                                    <span>
                                        Oddaljeni dostop
                                    </span>


                                    <div class="user-info float-right" v-if="getPermissions.length > 0">
                                        <div class="text-right"><a
                                                class="d-inline font-weight-bold pl-2">
                                            <i class="fa fa-user-circle"></i> {{userName}}
                                        </a></div>
                                        <div class="text-right"><a class="d-inline font-weight-bold pl-2"
                                                                   v-on:click="logout($event)"><i class="fa fa-sign-out-alt"></i>Odjavi se</a></div>
                                    </div>

                                </div>
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>

        <div class="goldenStripe"></div>


        <nav class="navbar navbar-expand-lg navbar-light bg-faded onWhiteBg">

            <div class="container">
                <button id="navbarTogglerButton1" type="button" class="navbar-toggler"><span
                        class="navbar-toggler-icon"></span></button>
                <div class="collapse navbar-collapse">
                    <ul class="navbar-nav">
                    </ul>
                </div>
            </div>
        </nav>


        <b-modal ref="metadata-modal" title="Podatki o uporabniku" size="lg">

            <div class="mb-5">
                <div class="row mb-5">
                    <div class="col-md-12 mb-0">

                        <div v-for="(item, index) in getPermissions" :key="index" class="mt-3 mb-0">
                            <h6>Vloga <b>{{item.description}}</b>
                            </h6>
                        </div>

                    </div>
                </div>
            </div>

            <div slot="modal-footer" class="w-100">
                <b-button
                        id="headerCloseModalButton1"
                        variant="primary"
                        class="float-right"
                        @click="closeModal">
                    OK
                </b-button>
            </div>

        </b-modal>

    </div>
</template>

<script>
    import _ from 'lodash';
    import {mapState, mapMutations} from 'vuex';
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faUserCircle, faSignOutAlt} from '@fortawesome/free-solid-svg-icons'

    library.add(faUserCircle);
    library.add(faSignOutAlt);


    export default {
        name: 'Header',
        components: {
            //Dropdown
        },

        data() {
            return {
                permissions: []
            };
        },
        mounted() {
            //const _this = this;

        },
        computed: {
            ...mapState([
            'userName'
            ]),
            getPermissions() {
                return [{ description: "pravica1" }]; //this.$store.getters.getPermissions;
            },
            displayPermissions() {
                let permissions = [];
                if(this.getPermissions.length === 0) {
                    return [];
                }
                _.map(this.getPermissions, function (val) {
                    if (permissions.indexOf(val.description) === -1) {
                        permissions.push(val.description);
                    }
                });

                return permissions;
            }
        },
        methods: {
            ...mapMutations([
                'clearUserDetails'
            ]),
            showUserDetailsModal: function () {
                this.$refs['metadata-modal'].show();
            },
            closeModal: function () {
                if (this.$refs['metadata-modal']) {
                    this.$refs['metadata-modal'].hide();
                }
            },
            emit: function(eventName, value) {
                /*eslint no-unused-vars: "off"*/
                return new Promise((resolve, reject) => {
                    this.$emit(eventName, value);
                    this.$nextTick(resolve);
                })
            },
            logout: async function () {
                await this.emit("logout");
                this.clearUserDetails();
                window.location.href = "/logout";
            }
        },
    };
</script>

<style lang="scss">
    .navbar {
        min-height: 70px;
    }

    .user-info a {
        cursor: pointer;

        &:hover {
            color: #524931 !important;
            text-decoration: underline !important;
        }
    }

</style>
